<template>
	<el-image
    :src="urls[0]"
    fit="contain"
    :preview-src-list="urls"
   >
  	<div slot="error" class="image-slot">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>
<script>
	export default {
		props: {
			urls: {
				type: Array,
				default: []
			},
		}
	}
</script>
<style lang="scss" scoped>
</style>